import {DateTime} from 'luxon';
import clsx from 'clsx'
import styles from './Status.module.scss'

export default ({ events, className }) => {
  if (!events || !events.length) {
    return null;
  }

  // Get earliest event ending later than now; if none, then latest event ended prior to now.
  // NOTE: appointments are evaluated by end date here, rather than start date, so that
  // a currently occuring appointment will count as a future event. All other events have the same start and end time.
  const primaryEvent = events.filter(t => !t.ended)[0] || events.filter(t => t.ended).reverse()[0];
  const dateTime = DateTime.fromISO(primaryEvent.start, {zone: primaryEvent.timeZone});

  return (
    <div className={clsx(styles.status, styles[primaryEvent.type], className)}>
      <span>
        <span className={styles.type}>{
          primaryEvent.type
        }</span> on <strong>{
          dateTime.toLocaleString(DateTime.DATE_MED)
        }</strong>{ primaryEvent.type !== 'delivery' &&
          <>
            {' at '} <strong>{dateTime.toLocaleString(DateTime.TIME_SIMPLE)}</strong>
          </>
        }
      </span>
    </div>
  )
}
